import styled from 'styled-components';
import { TMHeading, RegText, SmText, XsText, Bold } from './styles';

// Heading variant configurations
const headingVariants = {
    h1: {
        default: {
            fontSize: '3rem',
            lineHeight: '3.5rem',
            letterSpacing: '-0.0625rem'
        },
        small: {
            fontSize: '2.5rem',
            lineHeight: '3rem',
            letterSpacing: '-0.0625rem'
        },
        xs: {
            fontSize: '2rem',
            lineHeight: '2.5rem',
            letterSpacing: '-0.03125rem'
        }
    },
    h2: {
        default: {
            fontSize: '2.5rem',
            lineHeight: '3rem',
            letterSpacing: '-0.0625rem'
        },
        small: {
            fontSize: '2rem',
            lineHeight: '2.5rem',
            letterSpacing: '-0.03125rem'
        },
        xs: {
            fontSize: '1.5rem',
            lineHeight: '2rem',
            letterSpacing: '-0.03125rem'
        }
    },
    h3: {
        default: {
            fontSize: '2rem',
            lineHeight: '2.5rem',
            letterSpacing: '-0.03125rem'
        },
        small: {
            fontSize: '1.5rem',
            lineHeight: '2rem',
            letterSpacing: '-0.03125rem'
        }
    },
    h4: {
        default: {
            fontSize: '1.5rem',
            lineHeight: '2rem',
            letterSpacing: '-0.03125rem'
        },
        small: {
            fontSize: '1.25rem',
            lineHeight: '1.75rem',
            letterSpacing: '-0.03125rem'
        }
    },
    h5: {
        default: {
            fontSize: '1.25rem',
            lineHeight: '1.75rem',
            letterSpacing: '-0.03125rem'
        },
        small: {
            fontSize: '1rem',
            lineHeight: '1.5rem',
            letterSpacing: '0'
        }
    }
};

const getHeadingStyles = (level, variant = 'default') => {
    const styles =
        headingVariants[level][variant] || headingVariants[level].default;
    return `
        font-size: ${styles.fontSize};
        line-height: ${styles.lineHeight};
        letter-spacing: ${styles.letterSpacing};
    `;
};

export const H1 = styled.h1`
    ${TMHeading};
    ${({ variant }) => getHeadingStyles('h1', variant)}

    @media (max-width: 375px) {
        font-size: 2.5rem;
        line-height: 3rem;
        letter-spacing: -0.0625rem;
    }

    @media (max-width: 350px) {
        font-size: 2rem;
        line-height: 2.5rem;
        letter-spacing: -0.03125rem;
    }
`;
H1.displayName = 'H1';

export const H2 = styled.h2`
    ${TMHeading};
    ${({ variant }) => getHeadingStyles('h2', variant)}
`;
H2.displayName = 'H2';

export const H3 = styled.h3`
    ${TMHeading};
    ${({ variant }) => getHeadingStyles('h3', variant)}
`;
H3.displayName = 'H3';

export const H4 = styled.h4`
    ${TMHeading};
    ${({ variant }) => getHeadingStyles('h4', variant)}
`;
H4.displayName = 'H4';

export const H5 = styled.h5`
    ${TMHeading};
    ${({ variant }) => getHeadingStyles('h5', variant)}
`;
H5.displayName = 'H5';

export const H6 = styled.h6`
    ${TMHeading};
    font-size: 1rem; // 16px
    line-height: 1.625rem; // 26px
    letter-spacing: -0.03125rem; // -0.5px
`;

export const BodyReg = styled.p`
    ${RegText};
`;
BodyReg.displayName = 'BodyReg';

export const BodyRegBold = styled.p`
    ${RegText};
    ${Bold};
`;
BodyRegBold.displayName = 'BodyRegBold';

export const BodySm = styled.p`
    ${SmText};
`;
BodySm.displayName = 'BodySm';

export const BodySmBold = styled.p`
    ${SmText};
    ${Bold};
`;
BodySmBold.displayName = 'BodySmBold';

export const BodyXs = styled.p`
    ${XsText};
`;
BodyXs.displayName = 'BodyXs';

export const BodyXsBold = styled.p`
    ${XsText};
    ${Bold};
`;
BodyXsBold.displayName = 'BodyXsBold';
